// extracted by mini-css-extract-plugin
export default {"login-screen":"LoginPage_login-screen__+H4VK","login-box":"LoginPage_login-box__qsMkX"};